import { ConfigDataInterface } from './ConfigApiInterface';

export enum Config_SubsidyCreate_ActionsMenu_ApiEnum {
    'NOTHING' = 'NOTHING',
}

export enum Config_SubsidyCreate_Modules_ApiEnum {
    'form' = 'form',
}

export enum Config_SubsidyCreate_ActionsOther_ApiEnum {
    'NOTHING' = 'NOTHING',
}

export enum Config_SubsidyCreate_PageMenu_ApiEnum {
    'NOTHING' = 'NOTHING',
}

export enum Config_SubsidyCreate_PageSubMenu_ApiEnum {
    'NOTHING' = 'NOTHING',
}

export interface Config_SubsidyCreate_ApiInterface
    extends ConfigDataInterface<
        Config_SubsidyCreate_Modules_ApiEnum,
        Config_SubsidyCreate_ActionsMenu_ApiEnum,
        Config_SubsidyCreate_ActionsOther_ApiEnum,
        Config_SubsidyCreate_PageMenu_ApiEnum,
        Config_SubsidyCreate_PageSubMenu_ApiEnum
    > {
    _?: boolean;
}
